import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO title="Privacy Policy" description="Learn how Plymhair & Extensions collects, uses and protects your personal data." url="/privacy" />
      <Navbar />

      <section className="bg-foreground text-primary-foreground py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display text-5xl md:text-7xl mb-4">
            Privacy <span className="italic font-normal">Policy</span>
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 prose prose-neutral dark:prose-invert font-body prose-headings:font-display prose-h2:text-primary prose-h3:text-primary">
          <p>
            Plymhair & Extensions ("we", "our", "us") is committed to protecting and respecting your privacy. This policy explains how we collect, use, and protect your personal data when you visit our website or place an order with us.
          </p>

          <h2>Information We Collect</h2>
          <p>We may collect and process the following data:</p>
          <ul>
            <li><strong>Identity Data:</strong> Your name, username, or similar identifier.</li>
            <li><strong>Contact Data:</strong> Your email address, telephone number, and delivery address.</li>
            <li><strong>Transaction Data:</strong> Details of products you have purchased from us and payment details.</li>
            <li><strong>Technical Data:</strong> Your IP address, browser type, time zone, operating system, and platform.</li>
            <li><strong>Usage Data:</strong> Information about how you use our website and products.</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use your personal data for the following purposes:</p>
          <ul>
            <li>To process and fulfil your orders, including delivery and payment.</li>
            <li>To manage your account and provide customer support.</li>
            <li>To send you order confirmations, dispatch notifications, and delivery updates.</li>
            <li>To improve our website, products, and services.</li>
            <li>To send marketing communications where you have given your consent.</li>
            <li>To comply with legal obligations.</li>
          </ul>

          <h2>Data Sharing</h2>
          <p>We may share your personal data with:</p>
          <ul>
            <li>Our delivery partners (Royal Mail and other carriers) to fulfil your orders.</li>
            <li>Our payment processors to handle transactions securely.</li>
            <li>Law enforcement or regulatory bodies when required by law.</li>
          </ul>
          <p>We do not sell your personal data to third parties.</p>

          <h2>Data Security</h2>
          <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorised way. We limit access to your personal data to those who have a genuine business need.</p>

          <h2>Cookies</h2>
          <p>Our website uses cookies to distinguish you from other users and to improve your browsing experience. By continuing to use our website, you consent to our use of cookies.</p>

          <h2>Your Rights</h2>
          <p>Under data protection law, you have the right to:</p>
          <ul>
            <li>Request access to your personal data.</li>
            <li>Request correction of inaccurate personal data.</li>
            <li>Request erasure of your personal data.</li>
            <li>Object to processing of your personal data.</li>
            <li>Request restriction of processing.</li>
            <li>Request transfer of your personal data.</li>
            <li>Withdraw consent at any time where we rely on consent to process your data.</li>
          </ul>

          <h2>Data Retention</h2>
          <p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this privacy policy or our data practices, please contact us:</p>
          <p>
            <strong>Plymhair & Extensions</strong><br />
            21 Market Avenue, Plymouth, PL1 1PG<br />
            Email: info@plymhair.co.uk<br />
            Phone: 01752 651631
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
